<template>
  <a-modal
    :wrapClassName="disabeld ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="constructionYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.constructionYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="名称" prop="name">
          <a-input
            v-model="form.name"
            placeholder="请输入名称"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="类别" prop="type">
          <div class="flex">
            <a-select
              v-model="form.type"
              placeholder="请选择类别"
              :disabled="disabeld"
            >
              <a-select-option
                :value="item.text"
                v-for="item in jblist"
                :key="item.value"
                >{{ item.title }}</a-select-option
              >
            </a-select>
            <template v-if="form.type == '其他'">
              <a-input
                v-model="form.otherType"
                class="ipt-other"
                :disabled="disabeld"
              />
            </template>
          </div>
        </a-form-model-item>
        <a-form-model-item label="数量/人次" prop="num">
          <a-input-number
            v-model="form.num"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入数量"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item
          label="网址"
          prop="num"
          v-if="form.type == '网络德育阵地建设情况'"
        >
          <a-input-number
            v-model="form.webAddress"
            style="width: 100%"
            placeholder="请输入网址"
            :disabled="disabeld"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        constructionYear: "",
        name: "",
        type: "",
        num: "",
        webAddress: "",
      },
      rules: {
        constructionYear: [
          {
            required: true,
            message: "请选择年份",
            validator: (rule, value, callback) => {
              if (this.form.constructionYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入品牌建设名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择品牌建设类别",
            trigger: "change",
          },
        ],
        num: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
        webAddress: [
          {
            required: true,
            message: "请输入网址",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  components: { BaseEditor },
  mounted() {},
  methods: {
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      // this.form.constructionYear = value;
      const year = moment(value).format("YYYY");
      this.form.constructionYear = year + "";
      this.yearShowOne = false;
      this.$refs.ruleForm.clearValidate("constructionYear");
      // this.yearShowOne = false;
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.disabeld = false;
      this.getxwlist();
      this.getcgjb();
      this.getkclist();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.title = "新增品牌建设";
        this.form.constructionYear = new Date().getFullYear() + "";
      } else if (type == "edit") {
        this.title = "编辑品牌建设";
        this.form = {
          name: record.name,
          type: record.type,
          num: record.num,
          otherType: record.otherType,
          courseType: record.courseType,
          applyId: record.applyId,
          constructionYear: record.constructionYear,
          id: record.id,
          content: record.content,
          webAddress: record.webAddress,
        };
        if (record.amount == "1") {
          this.ifirst = true;
        } else {
          this.ifirst = false;
          this.form.content = "";
        }
        if (record.achievementType == "SZKC") {
          this.ishow = true;
        } else {
          this.ishow = false;
          this.form.courseType = "";
        }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑品牌建设";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        this.form = {
          name: record.name,
          type: record.type,
          num: record.num,
          otherType: record.otherType,
          courseType: record.courseType,
          applyId: record.applyId,
          constructionYear: record.constructionYear,
          id: record.id,
          content: record.content,
          webAddress: record.webAddress,
        };
        if (record.amount == "1") {
          this.ifirst = true;
        } else {
          this.ifirst = false;
          this.form.content = "";
        }
        if (record.achievementType == "SZKC") {
          this.ishow = true;
        } else {
          this.ishow = false;
          this.form.courseType = "";
        }
      } else {
        this.disabeld = true;
        this.title = "查看品牌建设";
        this.saveText = "关闭";
        this.form = {
          name: record.name,
          type: record.type,
          num: record.num,
          otherType: record.otherType,
          courseType: record.courseType,
          applyId: record.applyId,
          constructionYear: record.constructionYear,
          id: record.id,
          content: record.content,
          webAddress: record.webAddress,
        };
        if (record.amount == "1") {
          this.ifirst = true;
        } else {
          this.ifirst = false;
          this.form.content = "";
        }
        if (record.achievementType == "SZKC") {
          this.ishow = true;
        } else {
          this.ishow = false;
          this.form.courseType = "";
        }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=brand_build").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.constructionYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      //  	this.$refs.ruleForm.clearValidate();
      console.log(typeof this.form.constructionYear);
      if (
        typeof this.form.constructionYear == "object" &&
        this.form.constructionYear != "" &&
        this.type == "add"
      ) {
        this.form.constructionYear =
          new Date(this.form.constructionYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            postAction("/promotion/lxApplyConstruction/add", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success("添加成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              if (typeof this.form.constructionYear == "object") {
                params1.constructionYear =
                  new Date(this.form.constructionYear).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              if (typeof this.form.constructionYear == "object") {
                params.constructionYear =
                  new Date(this.form.constructionYear).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("/promotion/lxApplyConstruction/edit", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}

/deep/ .ant-input-number-handler-wrap {
  display: none;
}

.ipt-other {
  margin-left: 12px;
}
</style>